module.exports = __webpack_public_path__ + "static/media/Test27.4f173033.bmp";